<!-- <app-formulario-persona [ctx]="ctx" [formElements]=formElements
   (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"></app-formulario-persona> -->
<!-- <app-formulario-empresa [ctx]="ctx" [formElements]=formElements
   (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"></app-formulario-empresa> -->

<app-formulario-persona [ctx]="ctx" [formElements]=formElements *ngIf="['Persona'].includes(ctx.tipoFormulario)"
   (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"></app-formulario-persona>
<app-formulario-empresa [ctx]="ctx" [formElements]=formElements *ngIf="['Empresa'].includes(ctx.tipoFormulario)"
   (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"></app-formulario-empresa>